<template>
  <div class="calendar">
    <div class="itemday titleday" v-for="(item,i) in ['一','二','三','四','五','六','日']" :key="`xq${i}`">{{item}}</div>
    <div class="itemday" v-for="(item,i) in nWeek" :key="i">&nbsp;</div>
    <div class="itemday" v-for="(item,i) in day" :key="`${year}${math}${item.cDay}`" @click="clickday(item)">
      <div style="margin: 5px 4px;padding: 10px" :class="checkday(item)">
        <div :style="{color:new Date(date)>=new Date(`${year}-${math}-${item.cDay}`)?'':'#969696'}">{{item.cDay}}</div>
        <div style="white-space:nowrap;">
          <div class="longli">{{toyingli(item)}}</div>
          <slot :data="item"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calendar from './yingli.js'

export default {
  name: "Calendar",
  props:{
    year:[Number,String],
    math:[Number,String],
    check:{
      type:Boolean,//使用多选
      default:false
    },
    redio:{
      type:Boolean,//单选效果
      default:false
    },
    dayend:{
      type:Boolean,//当前日期之后的事件不触发
      default:true
    },
  },
  data(){
    return {
      nWeek:6,
      day:[],
      dayarr:[],//多选时选中日期
      date:'',//今天日期
      tday:'',//当前选中日期
    }
  },
  watch:{
    year(){this.computday();},
    math(){this.computday();},
    tday(v){
      let d=+v.split('-').pop();
      if(v==`${this.year}-${this.math}-${d}`){
        //this.dayarr=[...new Set([...this.dayarr,d])]
      }
    }
  },
  created() {
    this.computday();
    let date=new Date();
    this.date=`${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
    //this.tday=this.date;
  },
  methods:{
    //计算日历显示
    computday(){
      this.nWeek=calendar.solar2lunar(this.year, this.math, 1).nWeek-1;
      //格式化月份中每一天数据
      let day=calendar.solarDays(this.year, this.math);
      let arr=[];
      for(let i=1;i<=day;i++){
        arr.push(calendar.solar2lunar(this.year, this.math, i))
      }
      this.day=arr;
    },
    //转农历
    toyingli(obj){
      if(obj.festival)return obj.festival;//有节日显示节日
      if(obj.Term)return obj.Term;//有节气显示节气
      if(obj.IDayCn=='初一')return obj.IMonthCn;//有初一显示月份
      return obj.IDayCn
    },
    //单击某天时
    clickday(v){
      if(this.dayend){
        let dayend=new Date(this.date)>=new Date(`${v.cYear}-${v.cMonth}-${v.cDay}`)
        if(!dayend)return;
      }
      this.tday=`${v.cYear}-${v.cMonth}-${v.cDay}`;
      if(this.check){
        let i = this.dayarr.indexOf(v.cDay);
        if(i==-1){
          this.dayarr.push(v.cDay)
        }else{
          this.dayarr.splice(i,1)
        }
        this.dayarr.sort();
        this.dayarr=[...new Set(this.dayarr)]
        this.$emit('clickday',this.dayarr)
      }else{
        if(this.redio)this.dayarr=[v.cDay];
        this.$emit('clickday',v)
      }
    },
    //计算选中效果
    checkday(item){
      let str='';
      if(this.date==`${item.cYear}-${item.cMonth}-${item.cDay}`)str='dateborder '
      if(this.check){
        str+= (this.dayarr.includes(item.cDay)?'check':'')
      }else{
        str+= (this.tday==`${item.cYear}-${item.cMonth}-${item.cDay}`?'check':'')
      }

      return str;
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar {
  --size:14.25871%;
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: calc(var(--size) * 7);
  font-size: 18px;
  .itemday{
    box-sizing: border-box;
    text-align: center;
    display: inline-block;
    width: var(--size);
    height: var(--size);
    user-select:none;
    cursor: pointer;
    vertical-align: top;
    color: #666666;
  }
  .titleday{
    line-height: 40px;
    color: #4D4D4D;
  }
  .longli{
    color: #969696;
    font-size: 12px;
  }
  .dateborder{
    border: 1px solid #B79255;
    border-radius: 4px;
  }
  .check{
    .longli{
      color: #B79255;
      font-size:12px;
    }
    color: #B79255;
    border-radius: 4px;
    background: rgba(#B79255,0.1);
  }
}
</style>
